// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2NwSC","label":"CategoryService_label__foaS5","location":"CategoryService_location__JgY76"};